import React, {useContext, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import useFetch, {CachePolicies} from "use-http";
import style from "./profilePopup.module.scss";
import {LoadingOutlined,} from "@ant-design/icons";
import {Divider, Dropdown, Menu, Modal, Spin, Tooltip} from "antd";
import {useTranslation} from "react-i18next";
import GroupContainer from "../Groups/GroupContainer";
import GroupCard from "../Groups/GroupCard";
import SkeletonCard from "../Groups/SkeletonCard";
import {getUrlHttp} from "src/service/util.service";
import {pathRoutes} from "src/props/util.props";
import block from "src/assets/png/block.png";
import {AppContext} from "src/pages/context/App.context";
import UIModalReport from "../modal/UIModalReport";
import ButtonCenterClose from "src/components/shared/button/CloseButton/ButtonCenterClose";

import chatIcon from "src/assets/png/newIcon/My Center/Friend detail/fill/Chat.png";
import callIcon from "src/assets/png/newIcon/My Center/Friend detail/fill/Call.png";
import conferenceIcon from "src/assets/png/newIcon/My Center/Friend detail/fill/Video conference.png";
import moreIcon from "src/assets/png/newIcon/My Center/Friend detail/fill/More detail.png";
import reportIcon from "src/assets/png/newIcon/My Center/Friend detail/fill/Report.png";
import blockIcon from "src/assets/png/newIcon/My Center/Friend detail/fill/Block.png";
import {isTrue} from "src/utils/janus.utils";
import styles from "../../Home/CreatePost/CreatePost.module.scss";
import CenterConfirmModal from "../../../components/shared/Modal/CenterConfirmModal";
import {UserAPIEndpoint} from "../../../service/user.service";

const ProfilePopup = (props: any) => {
  const { onClose, profile, onRefresh } = props;

  const [isVoice, setIsVoice] = useState(false);
  const [isVideoCall, setIsVideoCall] = useState(false);
  const friendProfile = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL +
      `api/v1/users/detail/${profile?.username}`,
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const topic = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v2/groups/topic`,
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const voiceTopic = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v2/groups/topic`,
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const videoTopic = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v2/groups/topic`,
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const apiBlock = useFetch(
      window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + UserAPIEndpoint.BlockFriend,
      {
        cachePolicy: CachePolicies.NO_CACHE,
      }
  );


  const navigate = useNavigate();
  const { t } = useTranslation();
  const [mutualGroups, setMutualGroups]: any = useState(null);
  const [showConfirmBlock, setShowConfirmBlock] = useState<boolean>(false);
  const [toReport, setToReport]: any = useState(false);
  const appContext: any = useContext(AppContext);


  const antIcon = (
      <LoadingOutlined style={{ fontSize: 24, color: "#FFFFFF" }} spin />
  );

  const getFriendProfile = async () => {
    try {
      const res = await friendProfile.get();

      if (res.mutualGroups) {
        setMutualGroups(res.mutualGroups);
      } else {
        setMutualGroups([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleChat = async () => {
    const payload = {
      members: [{ userID: `${profile?.id}` }],
    };

    try {
      const res = await topic.post(payload);
      navigate(pathRoutes.Chat + `?id=${res.id}`);

      onRefresh?.();
      onClose();
    } catch (error) {
      console.error(error);
    }
  };

  const handleVoiceCall = async () => {
    const payload = {
      members: [{ userID: `${profile?.id}` }],
    };

    try {
      const res = await voiceTopic.post(payload);
      const path = `${pathRoutes.personalCall}?id=${res.id}&isVideoCall=false&calleeId=${profile?.id}`
      navigate(path);

      onRefresh?.();
      onClose();
    } catch (error) {
      console.error(error);
    }
  };

  const handleVideoCall = async () => {
    const payload = {
      members: [{ userID: `${profile.id}` }],
    };

    try {
      const res = await videoTopic.post(payload);
      const path = `${pathRoutes.personalCall}?id=${res.id}&isVideoCall=true&calleeId=${profile.id}`
      navigate(path);

      onRefresh?.();
      onClose();
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    if (!appContext.objectAccesses) return;
    setIsVoice(appContext.objectAccesses?.["PERSONAL_VOICE_CALL"]);
    setIsVideoCall(appContext.objectAccesses?.["PERSONAL_VIDEO_CALL"]);
  }, [appContext.objectAccesses]);

  useEffect(() => {
    // console.log(friend);
    if (!profile) {
      setMutualGroups([]);
      return
    }

    getFriendProfile();

    return () => {
      friendProfile.abort();
      topic.abort();
      voiceTopic.abort();
      videoTopic.abort();
    };
  }, [profile]);

  const block = () => {
    let data = {
      friendID: profile.id,
    };
    apiBlock.post("", data).then(res => {
      if (res?.code) return
      props.onBlock(profile?.id)
    })
  }

  useEffect(() => {
    if (props.show) return;
    setToReport(false)
  }, [props.show])

  return (
      <Modal
          centered
          open={props.show}
          className={styles.modalOveride}
          onCancel={onClose}
      >
        <CenterConfirmModal
            cancelText={"Cancel"}
            confirmText={apiBlock.loading ? <Spin indicator={antIcon} /> : t("Ok")}
            text={
              "Blocked contacts will no longer be able to call you or send you message"
            }
            visible={showConfirmBlock}
            onCancel={() => {setShowConfirmBlock(false)}}
            onConfirm={() => {
              block();
              setShowConfirmBlock(false);
            }}
        ></CenterConfirmModal>
        <div style={{ position: "absolute", top: 19, right: 19 }}>
          <ButtonCenterClose onClick={onClose} />
        </div>

        {!toReport && (
          <div
            style={{ width: "100%", overflow: "scroll" }}
            className={style.overrideScroll}
          >
            <div className={style.profilePart}>
              <div>
                <div
                  className={style.profileImage}
                  style={{
                    backgroundImage: `url(${getUrlHttp(
                      profile?.imageProfileURL
                    )})`,
                  }}
                ></div>
              </div>

              <div className={style.profileDetailBox}>
                <div className={style.name}>{`${profile?.firstname} ${
                    profile?.lastname ? profile?.lastname : ""
                }`}</div>
                <div className={style.email}>{profile?.email}</div>
                <div className={style.comunicationContainer}>
                  <Tooltip placement="bottom" title={t("Chat")}>
                    {topic.loading ? (
                      <Spin
                        indicator={
                          <LoadingOutlined
                            style={{ fontSize: "28px", color: "#0f4c82" }}
                          />
                        }
                      />
                    ) : (
                      <div
                        style={{ backgroundImage: `url(${chatIcon})` }}
                        className={style.communicateIcon}
                        onClick={handleChat}
                      />
                    )}
                  </Tooltip>
                  {isTrue(isVoice) && (
                    <Tooltip placement="bottom" title={"Call"}>
                      {voiceTopic.loading ? (
                        <Spin
                          indicator={
                            <LoadingOutlined
                              style={{ fontSize: "28px", color: "#0f4c82" }}
                            />
                          }
                        />
                      ) : (
                        <div
                          style={{ backgroundImage: `url(${callIcon})` }}
                          className={style.communicateIcon}
                          onClick={handleVoiceCall}
                        />
                      )}
                    </Tooltip>
                  )}
                  
                  {isTrue(isVideoCall) && (
                    <Tooltip placement="bottom" title={t("Video Conference")}>
                    {videoTopic.loading ? (
                      <Spin
                        indicator={
                          <LoadingOutlined
                            style={{ fontSize: "28px", color: "#0f4c82" }}
                          />
                        }
                      />
                    ) : (
                      <div
                        style={{ backgroundImage: `url(${conferenceIcon})` }}
                        className={style.communicateIcon}
                        onClick={handleVideoCall}
                      />
                    )}
                  </Tooltip>

                  )}
                  <Dropdown
                    overlay={
                      <Menu>
                        <Menu.Item
                          className={style.menuItem}
                          onClick={() => {
                            // appContext.setShowConfirmBlock(true);
                            setShowConfirmBlock(true);
                          }}
                        >
                          <div style={{ display: "flex" }}>
                            <img
                              src={blockIcon}
                              style={{ width: 26, height: 26 }}
                            />
                            <div className={style.textMenu}>{t("block")}</div>
                          </div>
                        </Menu.Item>
                        <Menu.Item
                          className={style.menuItem}
                          onClick={() => {
                            setToReport(true);
                          }}
                        >
                          <div style={{ display: "flex" }}>
                            <img
                              src={reportIcon}
                              style={{ width: 26, height: 26 }}
                            />
                            <div className={style.textMenu}>{t("report")}</div>
                          </div>
                        </Menu.Item>
                      </Menu>
                    }
                    placement="bottomCenter"
                    arrow
                    trigger={["click"]}
                  >
                    <img
                      src={moreIcon}
                      style={{ width: 26, height: 26, cursor: "pointer" }}
                    />
                  </Dropdown>
                </div>
              </div>
            </div>
            <Divider />
            <div className={style.groupPart}>
              <GroupContainer
                header={t("Groups")}
                number={mutualGroups !== null ? mutualGroups.length : 0}
              >
                <div className={style.cardGroup}>
                  {mutualGroups === null ? (
                    <SkeletonCard />
                  ) : (
                    mutualGroups.map((group: any, idx: number) => {
                      return (
                        <GroupCard
                          key={idx}
                          image={group.coverImgURL}
                          member={null}
                          groupName={group.name}
                          favorite={true}
                          joined={true}
                          groupID={group.id}
                          onRefresh={() => {
                            onRefresh?.();
                            onClose();
                          }}
                          group={group}
                          isChat={false}
                        />
                      );
                    })
                  )}
                </div>
              </GroupContainer>
            </div>
          </div>
        )}
        {toReport && (
          <UIModalReport
            onClose={() => {
              onClose();
            }}
            profile={profile}
            refId={profile?.id}
          ></UIModalReport>
        )}
      </Modal>
  );
};

export default ProfilePopup;
